<template>
    <div class="apprentice-simple-card">
        <div class="description">
            {{ $t('group_pair.choose_a_excel_list_below_to_upload') }}
        </div>
        <b-alert
            v-if="hasError"
            show
            variant="danger">
            {{ $t('group_pair.you_first_have_to_upload_an_excel_list') }}
        </b-alert>
        <b-form-group
            class="group-input-file"
            :label="$t('group_pair.excel_list')"
            label-for="grouppair-excel-input">
            <b-form-file
                class="apprentice-file-upload grouppair-excel-upload"
                id="grouppair-excel-input"
                v-model="file"
                accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :placeholder="$t('group_pair.upload_excel_list')">
            </b-form-file>
        </b-form-group>
        <br />
        <b-button
            class="btn-save btn-save-excel-input-grouppair"
            variant="primary"
            @click="save()">
            {{ $t('group_pair.upload') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-pair-import-upload-component',
    props: ['groupIn'],
    data() {
        return {
            group: this.groupIn,
            file: null,
            hasError: false,
        };
    },
    methods: {
        save() {
            this.hasError = false;
            if (this.file === null || this.file === '') {
                this.hasError = true;
                return;
            }

            const formData = new FormData();
            formData.append('groupId', this.group.id), formData.append('file', this.file);
            this.alert.saving();

            const headers = { 'Content-type': 'multipart/form-data' };

            axios
                .post(this.routes.groupPairImport(this.group.id), formData, { headers: headers })
                .then((response) => {
                    window.location.href = this.routes.groupPairImportSettings(this.group.id, response.data.id);
                })
                .catch(function (error) {
                    this.alert.ajaxError(error);
                });
        },
    },
};
</script>

<style scoped lang="scss">
.description {
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}
</style>
